/**
 * Save data to localStorage
 * @param {string} key - The key to store the data under
 * @param {any} data - The data to store (will be JSON stringified)
 */
export const saveToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error(`Error saving to localStorage (${key}):`, error);
  }
};

/**
 * Load data from localStorage
 * @param {string} key - The key to retrieve data from
 * @param {any} defaultValue - Default value if key doesn't exist
 * @returns {any} The parsed data or defaultValue if not found
 */
export const loadFromLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error loading from localStorage (${key}):`, error);
    return defaultValue;
  }
};

/**
 * Clear all app data from localStorage
 */
export const clearAppData = () => {
  try {
    localStorage.removeItem('tournament');
    localStorage.removeItem('teams');
    localStorage.removeItem('matches');
    localStorage.removeItem('currentMatchId');
  } catch (error) {
    console.error('Error clearing app data from localStorage:', error);
  }
};

/**
 * Export all app data to a JSON string
 * @returns {string} JSON string containing all app data
 */
export const exportAppData = () => {
  const keys = ['tournament', 'teams', 'matches'];
  const exportData = {};
  
  keys.forEach(key => {
    try {
      const data = localStorage.getItem(key);
      if (data) {
        exportData[key] = JSON.parse(data);
      }
    } catch (error) {
      console.error(`Error exporting ${key} data:`, error);
    }
  });
  
  return JSON.stringify(exportData, null, 2);
};

/**
 * Import app data from a JSON string
 * @param {string} jsonData - JSON string containing app data
 * @returns {boolean} Success status
 */
export const importAppData = (jsonData) => {
  try {
    const data = JSON.parse(jsonData);
    
    Object.entries(data).forEach(([key, value]) => {
      saveToLocalStorage(key, value);
    });
    
    return true;
  } catch (error) {
    console.error('Error importing app data:', error);
    return false;
  }
};
